// Routes opened directly from the DriveU app's webview (redirect links), not
// organic/browser traffic. Web ad-attribution/analytics (GA, Google Ads,
// LinkedIn, Clarity) is moot for these visitors since they already have the
// app installed. Same list used to skip the GTM tag in public/index.html
// (kept in sync manually there, since index.html can't import this module).
export const APP_WEBVIEW_ROUTES = [
  "/du-daily/",
  "/create-daily-bookings",
  "/create-daily-bookings-oneway",
  "/track-du-daily/",
];
